module.exports = __webpack_public_path__ + "family_watercolor-musings_1.jpg";